export const background = {
  default: '#F2F2F2',
  paper: '#FFFFFF',
};
